import React from 'react';
import AuthPageTemplate from './template/auth-page';
import ProfileMenu from './../ui/menu/profile';
import ProfileCarrierGroupsPanel from './../ui/panel/profile-carrier-groups';
import config from './../config';
import theme from './../ui/theme';

const ProfileCarrierGroupsPage = () => {
    return (
        <AuthPageTemplate childMenu={
            <ProfileMenu />
        }>
            {
                /* istanbul ignore next */
                config.features.allowCarrierGroups ? 
                    <ProfileCarrierGroupsPanel /> : 
                        <p style={{
                            ...theme.getGeneralTextStyle()
                        }}>
                            This feature is currently disabled
                        </p>
            }
        </AuthPageTemplate>
    );
};

export default ProfileCarrierGroupsPage;
